export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_4-34de70841ed89b3d29ab9560543296dc.png";